import { atom, selector } from "recoil";
import Lib from "library";

// 인증을 요청한 페이지 URL
export const certFromUrlState = atom({
  key: "certFromUrlState",
  default: "/mydata",
});

// 전체 선택된 수
export const checkedCountState = atom({
  key: "checkedCountState",
  default: 0,
});

// best50 내 선택된 수
export const bestCheckedCountState = atom({
  key: "bestCheckedCountState",
  default: 0,
});

// 검색창에서 선택된 수
export const searchCheckedCountState = atom({
  key: "searchCheckedCountState",
  default: 0,
});

// 선택된 기관
export const selectedOrgsState = atom({
  key: "selectedOrgsState",
  default: [],
});

// 재판매모델 - 서비스 채널별 인가된 API 정보
export const sncnApiState = atom({
  key: "sncnApiState",
  default: [],
});

// 재판매모델 - 정부지원금 코드
export const sbsdyCodeState = atom({
  key: "sbsdyCodeState",
  default: [],
});

export const getSbsdyCodeSelector = selector({
  key: "getSbsdyCodeSelector",
  get: async ({ get }) => {
    try {
      let sbsdyCodes = get(sbsdyCodeState);
      let data = [{ key: "전체분야", value: "" }];

      if (sbsdyCodes.length === 0) {
        const sbsdyApi = get(getSncnApiSelector).filter(
          (item) => item.api_nm === "정부지원금"
        );

        if (sbsdyApi) {
          sbsdyCodes = sbsdyApi[0].api_codes;
        }
      }

      sbsdyCodes.map((item) =>
        data.push({
          key: item.cd_nm,
          value: item.cd_id,
        })
      );

      return data;
    } catch (err) {
      throw err;
    }
  },
  set: ({ set }, newValue) => {
    set(sncnApiState, newValue);
  },
});

export const getSncnApiSelector = selector({
  key: "getSncnApiSelector",
  get: async ({ get }) => {
    try {
      console.log("getSncnApiSelector");
      const data = await Lib.myGet(`/api/auth/sncnApis/v1`);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  set: ({ set }, newValue) => {
    set(sncnApiState, newValue);
  },
});

// 선택된 기관중 업권 리스트
export const selectedIndustriesSelector = selector({
  key: "selectedIndustriesSelector",
  get: ({ get }) => {
    const selectedOrgs = get(selectedOrgsState);
    const newList = [];
    selectedOrgs.forEach((org) => {
      if (newList.indexOf(org.indstCd) < 0) newList.push(org.indstCd);
    });
    return newList;
  },
});

// 선택된 인증서 종류
export const certTypeState = atom({
  key: "certTypeState",
  default: undefined,
});

// 인증 종류 ex: 상세, 수정, 연장 등
export const certFromState = atom({
  key: "certFromState",
  default: undefined,
});

// cert_tx_id
export const certTxIdState = atom({
  key: "certTxIdState",
  default: undefined,
});

// 데이터 연동 데이터
export const linkedDataState = atom({
  key: "linkedDataState",
  default: [],
  effects: [
    ({ onSet }) => {
      onSet((newValue) => console.log(newValue));
    },
  ],
});


// 전송요구 및 제공 동의
export const transmitRequestState = atom({
  key: "transmitRequestState",
  default: {},
  effects: [
    // ({ onSet }) => onSet(newValue => console.log({newValue}))
  ],
});

// 전송요구 및 제공 동의 selector
export const transmitRequestSelector = selector({
  key: "transmitRequestSelector",
  get: ({ get }) => {
    const transmitRequest = get(transmitRequestState);
    // if (!transmitRequest.endDate) {
    //   let today = new Date();
    //   today = today.getTime() - 1000 * 60 * 60 * 24 * 366;
    //   const oneyear = Lib.dateFormat(today);
    //   return {
    //     ...transmitRequest,
    //     endDate: oneyear,
    //   };
    // } else {
    return transmitRequest;
    // }
  },
  set: ({ get, set }, newValue) => {
    const prev = get(transmitRequestState);
    const newObject = {
      ...prev,
      ...newValue,
    };
    if (newValue.endTerms) {
      const today = new Date();
      const isYear = Number(newValue.endTerms);
      // [1년후 계산시 오류 수정(하루차감) 20221014]
      //const oneyear = Lib.dateFormat(today.setFullYear(today.getFullYear() + 1))
      //newObject.endDate = oneyear
      today.setFullYear(today.getFullYear() + isYear);
      today.setDate(today.getDate() - isYear);
      newObject.endDate = Lib.dateFormat(today);
    }
    console.log('마이데이터 set 값', newObject)
    set(transmitRequestState, newObject);
  },
});

// 상세연동 데이터
export const detailResultDataState = atom({
  key: "detailResultDataState",
  default: undefined,
});

// reqCd 저장
export const reqCdState = atom({
  key: "reqCdState",
  default: undefined,
});

// 결과데이터
export const resultDataState = atom({
  key: "resultDataState",
  default: [],
});

// 결과 데이터 반환 셀렉터 (연동 결과)
export const resultDataSelector = selector({
  key: "resultDataSelector",
  get: ({ get }) => {
    const data = get(resultDataState);
    console.log('결과 데이터 반환 셀렉터 (연동 결과) data', data)
    const successList = [];
    const failList = [];
    for (let item of data) {
      // 여기서 item은 은행기준 array값
      const indstCd = item.indstCd; // 자산회사명 (은행, 카드사 등)
      let newList;
      let result;
      if (item.sucesYn) {
        // 초기 연동 :  기관 연동 결과가 바로 붙어나옴
        if (item.sucesYn === "Y") {
          newList = successList;
        } else {
          newList = failList;
        }
        let found = newList.find((row) => row.indstCd === indstCd);
        if (!found) {
          found = {
            indstCd: indstCd,
            data: [],
            count: 0,
          };
          newList.push(found);
        }
        found.data.push(item);
        found.count++;
      } else {
        // 연장일 경우 : asset_list 하위로 결과가 떨어짐
        for (let tagetInfo of item.targetInfoList) {
          console.log('targetInfoList 확인 ', tagetInfo)
          // tagetInfo n건 내려올 수 있음
          for (let asset of tagetInfo.assetList) {
            console.log('asset_list 확인 ', asset)
            // asset 가지고있는 자산의 n건 --> 여기서 성공여부 확인가능
            if (asset.sucesYn === "Y") {
              newList = successList;
            } else {
              newList = failList;
            }
            let found = newList.find((row) => row.indstCd === indstCd);
            if (!found) {
              found = {
                indstCd: indstCd,
                data: [],
                count: 0,
              };
              newList.push(found);
            }
            found.data.push(item);
            found.count++;
          }
        }
      }
    }
    // console.log('결과 데이터 성공리스트 ', successList)
    // console.log('결과 데이터 실패리스트 ', failList)
    return { successList, failList };
  },
});

// 선택된 계좌 최종 (전송요구권 작성용)
export const checkedResultDataState = selector({
  key: "checkedResultDataState",
  get: ({ get }) => {
    const resultData = Lib.deepCopy(get(resultDataState));
    if (Array.isArray(resultData)) {
      let returnData = []
      // is array
      for (let i = 0; i < resultData.length; i++) {
        let assetCount = 0;
        let result = resultData[i]
        if (result.sucesYn !== 'N' && Array.isArray(result.targetInfoList)) {
          const targetInfoList = result.targetInfoList
          for (var j = targetInfoList.length - 1; j >= 0; j--) {
            let resultTartgetInfoListAsset = []
            if (Array.isArray(targetInfoList[j].asset_list) && targetInfoList[j].asset_list.length > 0) {
              let removeIndex = null;
              for (var k = 0; k < targetInfoList[j].asset_list.length; k++) {
                const asset = targetInfoList[j].asset_list[k]
                if (typeof asset.checked == 'boolean') {
                  removeIndex = j
                  if (asset.checked === true) {
                    assetCount++;
                    resultTartgetInfoListAsset.push(asset)
                  }
                }
              }
              targetInfoList[j].asset_list = resultTartgetInfoListAsset
              if (removeIndex != null) {

                const scopeList = targetInfoList[j].scope != null ? targetInfoList[j].scope.split('.') : []
                const scope = scopeList.length > 1 ? scopeList[1] : ''
                if (scope !== 'list' && Array.isArray(targetInfoList[j].asset_list) && targetInfoList[j].asset_list.length === 0) {

                  targetInfoList.splice(removeIndex, 1)

                }
              }
            }
          }
        }
        if (assetCount > 0) {
          returnData.push(result)
        }
      }
      console.log('선택된 계좌 최종 return', returnData)
      return returnData
    } else {
      let returnData = {}
      let assetCount = 0;
      let result = resultData
      if (result.sucesYn !== 'N' && Array.isArray(result.targetInfoList)) {
        const targetInfoList = result.targetInfoList
        for (var j = 0; j < targetInfoList.length; j++) {
          let resultTartgetInfoListAsset = []
          if (Array.isArray(targetInfoList[j].asset_list) && targetInfoList[j].asset_list.length > 0) {
            let removeIndex = null;
            for (var k = 0; k < targetInfoList[j].asset_list.length; k++) {
              const asset = targetInfoList[j].asset_list[k]
              if (typeof asset.checked == 'boolean') {
                removeIndex = j
                if (asset.checked === true) {
                  assetCount++;
                  resultTartgetInfoListAsset.push(asset)
                }
              }

            }
            targetInfoList[j].asset_list = resultTartgetInfoListAsset
            if (removeIndex != null) {

              const scopeList = targetInfoList[j].scope != null ? targetInfoList[j].scope.split('.') : []
              const scope = scopeList.length > 1 ? scopeList[1] : ''
              if (scope !== 'list' && Array.isArray(targetInfoList[j].asset_list) && targetInfoList[j].asset_list.length === 0) {

                targetInfoList.splice(removeIndex, 1)

              }
            }
          }
        }
      }
      if (assetCount > 0) {
        returnData = result
      }
      console.log('선택된 계좌 최종 return', returnData)
      return returnData
    }
  },
});

// 선택된 결과데이터 중 업권목록
export const checkedResultIndustriesSelector = selector({
  key: "checkedResultIndustriesSelector",
  get: ({ get }) => {
    const results = get(checkedResultDataState);
    const newList = [];
    results.forEach((org) => {
      if (newList.indexOf(org.indstCd) < 0) newList.push(org.indstCd);
    });
    return newList;
  },
});

export const best50CountState = atom({
  key: "best50CountState",
  default: 0,
});

export const searchCountState = atom({
  key: "searchCountState",
  default: 0,
});

// 검색된 기관
export const searchDataState = atom({
  key: "searchDataState",
  default: "",
});
